import React, { useEffect, useState } from 'react';
import './SlidePreview.css';

const slides = [
  {
    title: 'Allah is Al-Khaliq (The Creator)',
    content: 'Explore how the design of ecosystems, cell biology, and natural cycles reflect Divine intentionality and purpose.'
  },
  {
    title: 'Gratitude in Action',
    content: 'Linking Akhlaq with science: Discuss how understanding the water cycle should inspire Shukr and responsible usage.'
  },
  {
    title: 'Qur’an and the World Around Us',
    content: 'Use Qur’anic verses about rain, night/day, or birds to bridge textbook science with divine signs and reflection.'
  }
];

const SlidePreview = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(intervalId);
  }, []);

  const { title, content } = slides[current];

  return (
    <div className="slide-preview-container">
      <div className="slide-content-box">
        <div className="slide-header">
          <span>Slide {current + 1} of {slides.length}</span>
        </div>
        <h4 className="slide-title">{title}</h4>
        <p className="slide-text">{content}</p>
      </div>
    </div>
  );
};

export default SlidePreview;
